module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"emptyBasket":"Jūsų krepšelis tuščias","goToOffer":"Eikite prie pasiūlymo!"},"en":{"emptyBasket":"Your cart is empty","goToOffer":"Go to the offer!"}}')
  delete Component.options._Ctor
}
